import {AbstractModalView} from "./AbstractModalView";
import {IModalView} from "./IModalView";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {ModalFooterConfigModel} from "../models/ModalFooterConfigModel";
import {IModalController, MK_MODAL_FOOTER_CONFIG} from "../controllers/IModalController";

export abstract class AbstractFooterModalView extends AbstractModalView<IModalController> implements IModalView<IModalController> {

  protected readonly configModel: ModalFooterConfigModel;

  protected constructor(dialogService: DialogService,
                        dialogRef: DynamicDialogRef) {
    super(dialogService, dialogRef);

    this.configModel = this.getController().getModel(MK_MODAL_FOOTER_CONFIG);
  }
}
